<!--
 * @Description:
 * @Author: rcle2
 * @Date: 2023-03-23 10:29:01
 * @LastEditTime: 2023-04-07 08:43:10
 * @LastEditors: rcle2
 * @FilePath: \debugger\src\components\exception\ExceptionPage.vue
-->
<template>
  <div class="exception">
    <div class="img">
      <img :src="config[type].img" />
      <!--<div class="ele" :style="{backgroundImage: `url(${config[type].img})`}"/>-->
    </div>
    <div class="content">
      <h1>{{config[type].title}}</h1>
      <div class="desc">{{config[type].desc}}</div>
      <div class="action">
        <a-button @click.native="logout" type="primary">注销</a-button>
      </div>
    </div>
    <div v-if="type === '403'" class="bottom-notice">
      <p>温馨提示：</p>
      <p>此系统为管理员使用的后台管理系统，提交报修请前往  信息门户-服务大厅生活服务类型下的报修申请服务项；</p>
    </div>
  </div>
</template>

<script>
import Config from './typeConfig'
const env = process.env.NODE_ENV
export default {
  name: 'ExceptionPage',
  props: ['type'],
  data () {
    return {
      config: Config
    }
  },
  methods: {
    logout () {
      let url = env === 'production'
        ? '/common/logout.do'
        : '/api/common/logout.do'
      window.location.href = url
    }
  }
}
</script>

<style lang="less">
.exception {
  min-height: 500px;
  height: 80%;
  align-items: center;
  text-align: center;
  padding-top: 150px;
  .img {
    display: inline-block;
    padding-right: 52px;
    zoom: 1;
    img {
      height: 360px;
      max-width: 430px;
    }
  }
  .content {
    display: inline-block;
    flex: auto;
    h1 {
      color: #434e59;
      font-size: 72px;
      font-weight: 600;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 16px;
    }
  }
  .bottom-notice {
    text-align: left;
    font-size: 18px;
    width: 900px;
    margin: 0 auto;
    margin-top: 50px;
  }
}
</style>
